// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-down--st4A5sQ4{position:absolute;left:50%;bottom:136px;transform:translateX(-50%);width:32px;height:32px;font-size:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll-down": `scroll-down--st4A5sQ4`
};
export default ___CSS_LOADER_EXPORT___;
